import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EmailNotificationStateType } from 'src/shared/types/src/lib/redux-types/email-notification-state.type';

const initialState: EmailNotificationStateType = {
    emailNotificationRemindLaterTime: 0,
}

const emailNotificationSlice = createSlice({
    name: 'emailNotificationSlice',
    initialState,
    reducers: {
        setRemindLaterTime: (state, action: PayloadAction<number>) => {
            state.emailNotificationRemindLaterTime = action.payload;
        },
    }
});

export const EmailNotificationActions = emailNotificationSlice.actions;
export default emailNotificationSlice.reducer;
